import React from "react";
import {
    isMobile,
    getPreviousMonday,
    getOrdinalNumber
} from '../../helpers/ApplicationHelper';

import ExtraInfoMobileSlider from './slider/extraInfoMobileSlider';
import { Regular } from '@worthy-npm/clarity'
import I18n from 'lib/i18n/i18n';
import ExtraInfoDesktopSlider from "./slider/extraInfoDesktopSlider";
import UserActions from "lib/userActions";

const logAction = (message, item, version) => {
    UserActions.lightListingPage(message, item.id, version);
};

const ExtraInfo = ({ item, openSlide, closeSlide, version, openSlideViaParent }) => {
    const previousMonday = getPreviousMonday();
    const lastUpdated = ` ${previousMonday.toLocaleString('en-US',
        { month: 'long' })} ${ getOrdinalNumber(previousMonday.getDate()) }, ${ previousMonday.getFullYear() }`
    const isMobileDevice = isMobile();
    const slides = I18n.getVar('listingPageLight::additionalInfo::list');

    return <div className='extra-info'>
        <h1 className="listing-title bolder h2">{ I18n.getString('listingPageLight::additionalInfo::title') }</h1>
        <h2 className='listing-title listing-sub-caption  h3'>
        {`Updated ${ lastUpdated }`}
        </h2>
        {
            isMobileDevice ? <ExtraInfoMobileSlider
                item={ item }
                closeSlide={ closeSlide }
                openSlide={ openSlide }
                version={ version }
                openSlideViaParent={openSlideViaParent}
                logAction={logAction}
               /> :
                <ExtraInfoDesktopSlider
                    closeSlide={ closeSlide }
                    openSlide={ openSlide }
                    version={ version }
                    openSlideViaParent={openSlideViaParent}
                    item={ item }
                    slides={ [{ ...slides[0] }, ...slides] }
                    logAction={logAction}/>
        }
    </div>;
};

export default ExtraInfo;
